export type CamAzimuth = {
    id: number,
    streamName: string,
    azimuth: number,
    epochTime: number
}

export type VideoPlayerType = "jwPlayer" | "iframe" | "webrtc" | "flow";
export type VideoPlayerSrc = "url" | "sample";

export interface VideoPlayerInfo {
    type: VideoPlayerType,
    src: VideoPlayerSrc
    signalingUrl: string
    applicationName: string
    videoMuted: boolean
    flowToken: string,
    enableDebugLogging: boolean;
    enableCamSpecificProvider: boolean;
    webrtcTokenRequired: boolean;
}

export enum WorkModeType {
    OCR = 1,
    FULL = 3
}